import React, { Component, PropTypes } from 'react';
import MDSpinner from 'react-md-spinner';

export default class Spinner extends Component {
  static propTypes = {
		dispatch : PropTypes.func.isRequired,
	}

  render() {

    return (
      <div className='spinner-fullscreen'>
        <MDSpinner singleColor='#2eb0e3' size={100} className='spinner'/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/Spinner/index.js